import React, { useState, useEffect } from 'react';
import { Zone } from '../../../XV2';
import { LocationCard } from '../../location/card/LocationCard';
import { UiGrid, UiText } from '@open-stack/ui';
import { useRouter } from '../../../hooks/router';
import { RootIdPage } from '../../../pages/id/RootIdPage';
import { useZoneHistory } from '../../../hooks/zone-history';
import { Outlet } from '../../../XV2';

interface Props {
    tagId: string;
    title?: string;
    zones: (Pick<Zone, 'id' | 'name'> & {
        outlet: Pick<Outlet, 'id' | 'name' | 'description' | 'image' | 'isClosed'>;
    })[];
}

export function TagOutletGroupToZone({ title, zones }: Props) {
    const { push, location } = useRouter();
    const [zoneId, setZoneId] = useState<number | undefined>(zones.length === 1 ? zones[0].id : undefined);
    const zoneHistory = useZoneHistory();
    const openZones = zones.filter((zone) => !zone.outlet.isClosed);

    useEffect(() => {
        const targetZoneId = zoneId || openZones.length === 1 ? openZones[0].id : undefined;

        if (targetZoneId) {
            zoneHistory.setPath(targetZoneId, location.pathname);
            push(RootIdPage, { id: targetZoneId });
        }
    }, [zoneId, JSON.stringify(openZones)]);

    return (
        <UiGrid padding={4} gap={4}>
            <UiText fontSize={4}>{title || 'Choose venue'}</UiText>

            <UiGrid minMax={240}>
                {zones.map((zone) => (
                    <LocationCard
                        name={zone.outlet.name}
                        description={zone.outlet.description}
                        image={zone.outlet.image}
                        isClosed={zone.outlet.isClosed}
                        onClick={() => {
                            zoneHistory.setPath(zone.id, location.pathname);
                            push(RootIdPage, { id: zone.id });
                        }}
                        key={zone.id}
                    />
                ))}
            </UiGrid>
        </UiGrid>
    );
}
